// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__bLYa9","link":"HeaderSimple_link__xYCd2"};